var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiCredentials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "themed-icon",
    d: "M8.31286 8.56601L16.2529 0.626007L18.3739 2.74701L16.9599 4.16101L19.0809 6.28201L15.5459 9.81801L13.4249 7.69701L10.4349 10.687C10.9854 11.7463 11.139 12.9676 10.8677 14.1302C10.5965 15.2928 9.91842 16.3201 8.95596 17.0264C7.99351 17.7327 6.81016 18.0715 5.61973 17.9816C4.4293 17.8916 3.31028 17.3789 2.46487 16.536C1.61902 15.6915 1.10368 14.572 1.01222 13.3802C0.92077 12.1885 1.25926 11.0034 1.96634 10.0397C2.67343 9.07607 3.70234 8.39758 4.86661 8.12723C6.03088 7.85687 7.25348 8.01254 8.31286 8.56601ZM7.41386 14.414C7.60489 14.2295 7.75725 14.0088 7.86207 13.7648C7.96689 13.5208 8.02206 13.2584 8.02437 12.9928C8.02667 12.7273 7.97607 12.4639 7.87551 12.2181C7.77495 11.9723 7.62644 11.749 7.43866 11.5612C7.25087 11.3734 7.02757 11.2249 6.78177 11.1244C6.53598 11.0238 6.27262 10.9732 6.00706 10.9755C5.7415 10.9778 5.47906 11.033 5.23506 11.1378C4.99105 11.2426 4.77036 11.395 4.58587 11.586C4.22155 11.9632 4.01996 12.4684 4.02452 12.9928C4.02907 13.5172 4.23941 14.0188 4.61023 14.3896C4.98104 14.7605 5.48267 14.9708 6.00706 14.9754C6.53146 14.9799 7.03666 14.7783 7.41386 14.414Z",
    fill: "#B9B8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiCredentials);
export default __webpack_public_path__ + "static/media/api_credentials.ebb1805f0cd580be2aab4417bce8649c.svg";
export { ForwardRef as ReactComponent };